import { nvFetch } from '../helpers/nvFetch';
import { completelyFetchResource } from '../helpers/resources';
import {
  ApiPhonebookEntry,
  ApiPhonebookEntryCreate,
} from '../types/PhonebookEntry';
import { ApiPhoneExtension } from '../types/PhoneExtension';
import { ApiVirtualExtension } from '../types/VirtualExtension';

export type SubscriptionStatus = 'ACTIVE' | 'INACTIVE' | 'RINGING' | 'UNKNOWN';
export type SubscriptionState = {
  status?: SubscriptionStatus;
  subscribed?: boolean;
  subscription?: any;
};

export type AugmentedPhoneExtension = ApiPhoneExtension & {
  username: string;
} & SubscriptionState;

export type CombinedContact =
  | ApiPhonebookEntry
  | AugmentedPhoneExtension
  | ApiVirtualExtension;

export const getContactNumber = (contact: CombinedContact): string =>
  contact.type === 'phonebookentry'
    ? contact.phoneNumber
    : contact.shortNumber;

// TODO update store page by page, don't wait for all pages to finish.
export const getPhonebook = async (customerId: string) => {
  const fetchRes = await completelyFetchResource<ApiPhonebookEntry>(
    `phonebook`,
    '',
    { pageSize: 200 },
    customerId,
  );
  return fetchRes;
};

export const getPhoneExtensions = async (customerId: string) => {
  const fetchRes = await completelyFetchResource<ApiPhoneExtension>(
    `endpoints`,
    '&type=phone&extended=true',
    { pageSize: 200 },
    customerId,
  );
  return fetchRes.map((e) => ({
    ...e,
    username: String(`00000${e.id}`).slice(-6),
  })) as AugmentedPhoneExtension[];
};

export const getVirtualExtensions = async (customerId: string) => {
  const fetchRes = await completelyFetchResource<ApiVirtualExtension>(
    `endpoints`,
    '&type=virtual',
    { pageSize: 200 },
    customerId,
  );
  return fetchRes;
};

export const createPhonebookEntry = async (
  customerId: string,
  entry: ApiPhonebookEntryCreate,
) => {
  const fetchRes = await nvFetch(`/customers/${customerId}/phonebook`, {
    method: 'POST',
    body: JSON.stringify(entry),
  });
  return (await fetchRes.json()) as ApiPhonebookEntry;
};

export const deletePhonebookEntry = async (
  customerId: string,
  entryId: string,
) => {
  await nvFetch(`/customers/${customerId}/phonebook/${entryId}`, {
    method: 'DELETE',
  });
};

export const editPhonebookEntry = async (
  customerId: string,
  entryId: string,
  entry: ApiPhonebookEntryCreate,
) => {
  const fetchRes = await nvFetch(
    `/customers/${customerId}/phonebook/${entryId}`,
    {
      method: 'PUT',
      body: JSON.stringify({
        ...entry,
        id: entryId,
        email: entry.email || undefined,
      }),
    },
  );
  return (await fetchRes.json()) as ApiPhonebookEntry;
};

export const editPhoneExtension = async (
  customerId: string,
  entry: ApiPhoneExtension,
) => {
  const fetchRes = await nvFetch(
    `/customers/${customerId}/endpoints/${entry.id}`,
    {
      method: 'PUT',
      body: JSON.stringify(entry),
    },
  );
  return (await fetchRes.json()) as ApiPhoneExtension;
};
